"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const classes_1 = require("../classes");
class CallActivityWithRetryAction {
    constructor(functionName, retryOptions, input) {
        this.functionName = functionName;
        this.retryOptions = retryOptions;
        this.actionType = classes_1.ActionType.CallActivityWithRetry;
        this.input = classes_1.Utils.processInput(input);
        classes_1.Utils.throwIfEmpty(functionName, "functionName");
        classes_1.Utils.throwIfNotInstanceOf(retryOptions, "retryOptions", new classes_1.RetryOptions(1, 1), "RetryOptions");
    }
}
exports.CallActivityWithRetryAction = CallActivityWithRetryAction;
//# sourceMappingURL=callactivitywithretryaction.js.map